module.exports = __webpack_public_path__ + "img/huojia.2968038c.png";